import ApiReceiver from './ApiReceiver';
import IApiCommand from './IApiCommand';

abstract class AbstractApiCommand<T> implements IApiCommand<T> {
  protected readonly apiReceiver: ApiReceiver;

  constructor(apiReceiver: ApiReceiver) {
    this.apiReceiver = apiReceiver;
  }

  runOnlyOnChange(): boolean {
    return false;
  }

  getDataStringRepresentation(): string | null {
    return null;
  }

  getIdentifier(): string | null {
    return null;
  }

  // IApiCommand
  runCommand(): Promise<T> {
    return this.handleRunCommand();
  }

  abstract handleRunCommand(): Promise<T>;
}

export default AbstractApiCommand;
